import React from 'react'
import defAvatar from "../../images/default avatar.jpg";
import { useParams, NavLink } from 'react-router-dom';
import DashHeader from '../mini/DashHeader';
import { useRidersQuery, useUnapprovedRidersQuery } from '../../redux/services/usersApi';

const Rider = () => {
    
    const { riderId } = useParams()
    const { rider } = useRidersQuery(undefined, {
        selectFromResult: ({data}) => ({
            rider: data?.data?.find((us) => us._id === riderId)
        })
    })

    const { unapprovedRider } = useUnapprovedRidersQuery(undefined, {
        selectFromResult: ({data}) => ({
            unapprovedRider: data?.data?.find((us) => us._id === riderId)
        })
    })

    let selectedUser = rider ? rider : unapprovedRider

    Date.longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const d = new Date(selectedUser?.createdAt || selectedUser?.date)
    const date = Date.longMonths[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear()

    return (
        <>
            <DashHeader title={selectedUser?.fullName} />
            <nav className='mt-2 d-flex nav-tab'>
                <NavLink to={"/dashboard/rider/"+riderId} className="text-decoration-none d-inline-block ps-0 p-2 my-2 border-bottom-1 top-tab active-top-tab">
                    General information
                </NavLink>
                <NavLink to={"/dashboard/rider-history/"+riderId} className="text-decoration-none d-inline-block p-2 my-2 border-bottom-1 top-tab">
                    Rider History
                </NavLink>
                <NavLink to={"/dashboard/statements/"+riderId} className="text-decoration-none d-inline-block p-2 my-2 border-bottom-1 top-tab">
                    Statements
                </NavLink>
                <NavLink to={"/dashboard/documents/"+riderId} className="text-decoration-none d-inline-block pe-4 p-2 my-2 border-bottom-1 top-tab">
                    Documents
                </NavLink>
            </nav>
            <div className="pull-up">
                <div className="content row mt-5">
                    <div className="col-md-4 text-center">
                        <img src={selectedUser?.profilePicture?.url || defAvatar} style={{ height: "140px", width: "140px", borderRadius: "50%" }} alt="" />
                    </div>
                    <div className="col-md-8 my-md-0 my-3">
                        <form action="">
                            <div className="form-group d-inline-block mb-4">
                                <label htmlFor="date" className="mb-2 fw-normal">Start Date</label>
                                <div className="input form-control p-2 bg-light">
                                    <i className="ri-calendar-line me-2"></i> 
                                    {date}
                                </div>
                            </div>
                            <div className="form-group d-inline-block mb-4 me-4">
                            </div> <br />

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group mb-4 me-4">
                                        <label htmlFor="fName" className="mb-2 fw-normal">First Name</label>
                                        <div className="input form-control bg-light p-2">
                                            {selectedUser?.fullName?.split(" ")[0]}
                                        </div>
                                    </div>
                                    <div className="form-group mb-4 me-4">
                                        <label htmlFor="email" className="mb-2 fw-normal">Email Address</label>
                                        <div className="input form-control bg-light p-2">
                                            {selectedUser?.email}
                                        </div>
                                    </div>
                                    <div className="form-group mb-4 me-4">
                                        <label htmlFor="bank" className="mb-2 fw-normal">Bank Name</label>
                                        <div className="input form-control bg-light p-2">
                                            {selectedUser?.bankName || "Not provided"}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group mb-4 me-4">
                                        <label htmlFor="lName" className="mb-2 fw-normal">Last Name</label>
                                        <div className="input form-control bg-light p-2">
                                            {selectedUser?.fullName?.split(" ")[1]}
                                        </div>
                                    </div>
                                    <div className="form-group mb-4 me-4">
                                        <label htmlFor="phone" className="mb-2 fw-normal">Phone Number</label>
                                        <div className="input form-control bg-light p-2">
                                            {selectedUser?.phone}
                                        </div>
                                    </div>
                                    <div className="form-group mb-4 me-4">
                                        <label htmlFor="account" className="mb-2 fw-normal">Account Number</label>
                                        <div className="input form-control bg-light p-2">
                                            {selectedUser?.accountNumber || "Not provided"}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Rider
